import React, { useEffect, useState } from 'react';
import { CommonHeader, Loader, ErrorSuccessModal } from '../../components/commons';
import { RevenueInvoiceList, ExpenseInvoiceList, OtherEntriesList } from '../../components/Invoicing';
import { connect } from 'react-redux';
import { RootState } from '../../redux/rootReducers';
import { GetClientColumnPayload } from '../../commonTypes/invoicingTypes';
import {
  resetInvoiceStatusCode,
  getIndividualClientColumnAction,
  resetInvoicingError,
  resetInvoicingSuccess
} from '../../redux/invoicing';
import { resetSession } from '../../redux/auth';
import { AddIcon, UserIcon } from '../../components/Icon'
import { InvoiceListType } from '../../redux/invoicing/invoicingTypes';
import { useMenuCheck } from '../../customHooks/useMenuCheck';
import { useParams } from 'react-router-dom';

type AppProps = {
  history: any;
  token: string | null;
  fetching: boolean;
  success: number | null;
  error: string | null;
  companyName:string;
  statusCode: number | null;
  dispatchGetClientColumnListAction: Function;
  dispatchResetSession: () => void;
  dispatchResetInvoiceStatusCode: () => void;
  dispatchResetInvoicingError: () => void;
  dispatchResetInvoicingSuccess: () => void;
  userData: any;

};

interface TabsType {
  name: string;
  label: string;
  display:boolean;
}

const tabs: TabsType[] = [
  {
    name: 'Expense Invoices',
    label: 'expenses',
    display:false
  },
  {
    name: 'Receipt Invoices',
    label: 'revenue',
    display:false
  },
  {
    name: 'Other Entries',
    label: 'others',
    display:false
  },
]

const InvoiceListings = ({
  history,
  token,
  fetching,
  userData,
  success,
  error,
  statusCode,
  companyName,
  dispatchResetSession,
  dispatchResetInvoicingError,
  dispatchGetClientColumnListAction,
  dispatchResetInvoicingSuccess
}: AppProps) => {
  const {id}:any=useParams()
  const pathname=history.location?.pathname
  const client_code = history && history.location && history.location.state && history.location.state.client_code ? history.location.state.client_code : (id?.includes("#") ? id?.split("#")[0] : id );
  const company_name = history && history.location && history.location.state && history.location.state.company_name ? history.location.state.company_name : '';

    	//========== User Management ==========//
	const [isPurchaseEntryPresent, setIsPurchaseEntryPresent] = useMenuCheck();
	const [isSalesEntryPresent, setIsSalesEntryPresent] = useMenuCheck();
  const [isOthersEntriesPresent, setIsOthersEntriesPresent] = useMenuCheck();
  const [isExpenseInvoiceListPresent,setIsExpenseInvoiceLIstPresent]=useMenuCheck()
  const [isSalesInvoiceListPresent,setIsSalesInvoiceListPresent]=useMenuCheck()
  const [isOtherInvoiceListPresent,setIsOtherInvoiceListPresent]=useMenuCheck()
	//====================//

  let hash = history?.location?.hash?.replace(/[^\w\s]/gi, '');
   
  let activeUrlTab ;
  const [activeTab, setActiveTab] = useState<string | undefined>(activeUrlTab)


  useEffect(() => {
    if (token) {
      let finalData = {
        token,
        client_code
      }
      setIsExpenseInvoiceLIstPresent("Expense Invoice List","menu")
      setIsSalesInvoiceListPresent("Revenue Invoice List","menu")
      setIsOtherInvoiceListPresent("Others Invoice List","menu")
      setIsOthersEntriesPresent("Other Entry","menu")
      setIsSalesEntryPresent("Sales Entry","menu")
      setIsPurchaseEntryPresent("Purchase Entry","menu")
      dispatchGetClientColumnListAction(finalData);
    }
    dispatchResetInvoicingError();
    dispatchResetInvoicingSuccess();
  }, []);

   
   

  useEffect(()=>{
    activeUrlTab = hash ? hash : isExpenseInvoiceListPresent ? tabs[0].label : isSalesInvoiceListPresent ? tabs[1].label : tabs[2].label;
    setActiveTab(activeUrlTab)
  
    
    if(isExpenseInvoiceListPresent===true){
     tabs?.forEach((e:any)=>{
         if(e.label==="expenses"){
           return e.display=true
         }
     })
    }
     if(isSalesInvoiceListPresent===true){
     tabs?.forEach((e:any)=>{
       if(e.label==="revenue"){
         return e.display=true
       }
   })
    }
     if(isOtherInvoiceListPresent===true){
     tabs?.forEach((e:any)=>{
       if(e.label==="others"){
         return e.display=true
       }})
    }
     if(isExpenseInvoiceListPresent===false){
     tabs?.forEach((e:any)=>{
       if(e.label==="expenses"){
         return e.display=false
       }
   })
    }
    if(isSalesInvoiceListPresent===false){
     tabs?.forEach((e:any)=>{
       if(e.label==="revenue"){
         return e.display=false
       }
   })
    }
    if(isOtherInvoiceListPresent===false){
     tabs?.forEach((e:any)=>{
       if(e.label==="others"){
         return e.display=false
       }})
    }
   },[isExpenseInvoiceListPresent,isSalesInvoiceListPresent,isOtherInvoiceListPresent])

   
   
  const handleAddInvoice = (type: string | undefined) => {
    history.push({pathname:`/invoice/add-invoice/${ client_code }?type=${ type }`,state:{client_code,company_name}})
  }

  const handleTabChange = (tabs: string) => {
    setActiveTab(tabs)

    const {
      location = {}
    } = history
    let newUrl=location?.pathname?.includes("#") ? location?.pathname?.split("#")[0] : location?.pathname

    history.push({
      ...location,
      pathname:newUrl,
      search: "",
      hash: `#${ tabs }`,

    });
  }

  useEffect(()=>{
    if(pathname?.length>0 && pathname?.includes("#")){
      handleTabChange(pathname?.split("#")[1] )
    }
  },[pathname])

  const renderTabs = () => {

    let finalTab = tabs.map((tab: TabsType) => {
      return (
        <div
          className={tab.display ? "tab-style mr-5 " : ""}
          key={tab.label}
          onClick={() => { handleTabChange(tab.label) }}
        >
          {tab.display && <div className={`tab-header ${ activeTab === tab.label ? "active" : "" }`}>{tab.name}</div>}
          <div
            className={`${ activeTab === tab.label
              ? "active-tab-bottom-border"
              : "not-active-tab-bottom-border"
              }`}
          ></div>
        </div>
      );
    });

    return finalTab;
  }

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="Logout"
            onPress={() => {
              dispatchResetSession();
              dispatchResetInvoicingError();
            }}
            statusCode={statusCode}
          />
        )
      } else if (error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => dispatchResetInvoicingError()}
          />
        )
      }
    }
    return false;
  }
   
  let component;
 
  if (activeTab === 'expenses') {
    component = <ExpenseInvoiceList
      client_code={client_code}
      history={history}
      company_name={company_name}
      isExpenseInvoiceListPresent={isExpenseInvoiceListPresent}
    />
  }
  else if (activeTab === 'revenue') {
    component = <RevenueInvoiceList
      client_code={client_code}
      history={history}
      company_name={company_name}
    />
  }
  else if (activeTab === 'others') {
    component = <OtherEntriesList
      client_code={client_code}
      history={history}
      company_name={company_name}
    />
  }

  return (
    <div className="row">
      <div className="col-md-4 mb-3">
        <CommonHeader title="All Invoices" />
        <div className="d-flex align-items-center">
          {client_code ? <>
            <UserIcon /> &nbsp;
            {!!company_name ? company_name : companyName}   {"(" + client_code + ")"}</> : null}
        </div>
      </div>
      <div className="col-md-8">
        <div className="d-flex flex-row justify-content-end mr-5">
         {isPurchaseEntryPresent && <button
            className="btn btn-primary mr-3"
            onClick={() => { handleAddInvoice('expenses') }}
          >
            <AddIcon />  Purchase Entry
          </button>}
          {isSalesEntryPresent && <button
            className="btn btn-secondary mr-3"
            onClick={() => { handleAddInvoice('revenue') }}
          >
            <AddIcon />  Sales Entry
          </button>}
         {isOthersEntriesPresent && (<button
            className="btn btn-outline-secondary"
            onClick={() => { handleAddInvoice('others') }}
            style={{ color: '#201D1D' }}
          >
            <AddIcon color="#201D1D" />  Other Entries
          </button>)}
        </div>
      </div>
      <div className="col-md-12">
        <div className="tab-container d-flex flex-row justify-content-start align-items-center">
          {renderTabs()}
        </div>
      </div>
      <div className="col-md-12 mt-4 ">
        <div className="card p-3">
          {component}
        </div>
      </div>
      {fetching && <Loader />}
      {handleErrorModal()}
    </div>
  )
}

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  userData: state.auth.loginData,
  fetching: state.invoicing.fetching,
  success: state.invoicing.success,
  error: state.invoicing.error,
  statusCode: state.invoicing.statusCode,
  companyName: state.auth.companyName
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchGetClientColumnListAction: (data: GetClientColumnPayload) =>
    dispatch(getIndividualClientColumnAction(data)),
  dispatchResetInvoiceStatusCode: () => dispatch(resetInvoiceStatusCode()),
  dispatchResetInvoicingError: () => dispatch(resetInvoicingError()),
  dispatchResetInvoicingSuccess: () => dispatch(resetInvoicingSuccess()),
})

export default connect(mapStateToProps, mapDispatchToProps)(InvoiceListings);
